<template>
  <v-form ref="form">
    <v-autocomplete
      class="tema-eixo-combo"
      id="temas-select"
      v-model="filter.temaId"
      item-text="nome"
      item-name="nome"
      item-value="temaId"
      :items="temas"
      :label="label ? label : 'Temas'"
      hide-details="auto"
      solo
      :rules="rules"
      :placeholder="label ? label : 'Temas'"
      v-on:change="$emit('temasChange', filter.temaId)"
      :clearable="true"
      multiple
      :readonly="false"
    >
      <template v-slot:selection="{ item, index }">
        <span v-if="index < maxDisplay"
          >{{ diminuirValue(item.nome) }} &nbsp;</span
        >
        <span v-if="index === maxDisplay" class="grey--text caption"
          >(+{{ filter.temaId && filter.temaId.length - maxDisplay }}
          {{ label ? label : "Temas" }})</span
        >
      </template>
      <template slot="no-data">
        Nenhum {{ label ? label : "Temas" }} retornado
      </template>
    </v-autocomplete>
  </v-form>
</template>

<script>
import { temaAPI } from "../../tema/API/temaAPI";

export default {
  name: "ComboboxTemasByEixo",
  props: {
    filter: { type: Object, default: { temaId: [] } },
    eixoId: { type: Number },
    label: { type: String, default: "Temas" },
    rules: { type: Array },
  },
  mounted() {
    this.loadTemas();
  },
  watch: {
    "filter.eixoId": {
      async handler(old, val) {},
      deep: true,
    },
  },
  methods: {
    diminuirValue(item) {
      if (item && item.length > 10) {
        return item.substring(0, 10) + "...";
      }

      return item;
    },
    loadTemas() {
      temaAPI
        .listByEixo(this.eixoId)
        .then((resp) => {
          this.temas = resp.data;
        })
        .catch();
    },

    async isValid() {
      return await this.$refs.form.validate();
    },
  },

  data() {
    return {
      maxDisplay: 1,
      temas: [],
    };
  },
};
</script>
